<template>
 <div  @mouseover="menuOver = true" @mouseout="menuOver = false" id="noShadowOnMenu">
  <div>
    <q-item :href="menuData.link">
      {{menuData.menu}}
    </q-item>
  </div>
  <q-menu v-model="menu" anchor="top right" square style="min-width: 200px;" >
    <q-list @mouseover.native="listOver = true" @mouseout.native="listOver = false" >
      <template v-for="(submenu) in menuData.submenu">
        <q-item clickable v-close-popup :href="submenu.link">
          <q-item-section class="submenuItem">{{submenu.sub}}</q-item-section>
        </q-item>
      </template>
    </q-list>
  </q-menu>
 </div>
</template>

<script>

import { debounce } from 'quasar'
import { ref } from 'vue'

export default {
  name: 'TopMenuItem',
  props: ['menuData'],

  data () {
    let currentInterlval = ref(null)
    return {
      menu: ref(false),
      menuOver: ref(false),
      listOver: ref(false),
      showOn: true,
      currentInterlval,
      intervalSet: false
    }
  },
  methods: {
    debounceFunc: debounce(function() { this.checkMenu() }, 100),
    checkMenu () {
      if(!this.menuOver && !this.listOver && this.menu){
        this.menu = false;
        clearInterval(this.currentInterlval);
        this.intervalSet = false;
      }

      if (this.menuOver || this.listOver) {
        this.menu = true;
        if(!this.intervalSet){
          this.intervalSet = true;
          this.currentInterlval = setInterval(() => {
            this.checkMenu()
          },100)
        }
      }
      else {
        this.menu = false;
        clearInterval(this.currentInterlval);
        this.intervalSet = false;
      }
    }
  },
  watch: {
    menuOver (val) {
      this.debounceFunc()
    },
    listOver (val) {
      this.debounceFunc()
    }
  }

}
</script>


<style>

body > div.q-menu.q-position-engine.scroll.q-menu--square {
  box-shadow: 0 0 0 0;
}

.submenuItem {
  color: #C4C5C6;
  font-weight: 400;
  font-size: 17px;
  height: 45px;
}

.submenuItem:hover {
  color: #434549;
}


</style>
